'use client';

import { useSyncExternalStore } from 'react';
import { readJson, stringField } from '@/lib/jsonBody';

const OWN_SHA = process.env.NEXT_PUBLIC_BUILD_SHA ?? '';
const POLL_MS = 60_000;

let stale = false;
const listeners = new Set<() => void>();
let started = false;

function startPolling(): void {
  if (started || typeof window === 'undefined') return;
  if (!OWN_SHA || OWN_SHA === 'dev') return;
  started = true;
  const check = async (): Promise<void> => {
    try {
      const res = await fetch('/build-version', { cache: 'no-store' });
      if (!res.ok) return;
      const sha = stringField(await readJson(res), 'sha');
      if (!stale && sha && sha !== 'dev' && sha !== OWN_SHA) {
        stale = true;
        for (const l of listeners) l();
      }
    } catch {
    }
  };
  window.setInterval(check, POLL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check();
  });
  void check();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  startPolling();
  return () => listeners.delete(cb);
}

export function useBuildStale(): boolean {
  return useSyncExternalStore(subscribe, () => stale, () => false);
}
